var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack109({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 3.8 11.5 1.94 11.64 5.9 15 8 11.64 10.1 11.5 14.06 8 12.2 4.5 14.06 4.36 10.1 1 8 4.36 5.9 4.5 1.94 8 3.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack109);
export default __webpack_public_path__ + "static/media/Symbolpack_1_09.7b5b1d3f7c7189f2ec0ea487083c799e.svg";
export { ForwardRef as ReactComponent };